import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reset-password-email-sent',
  templateUrl: './reset-password-email-sent.component.html',
  styleUrls: ['./reset-password-email-sent.component.scss']
})
export class ResetPasswordEmailSentComponent implements OnInit {

  sectionTitle = 'Reset Your Password'
  SIResetCompletedInfo = {
    sentEmnail: "We've sent an email for reselting your password to:",
    emailContact: 'test@test.com',
    emailReceive: 'You should receive it in the next couple of minutes.'
  }

  constructor() { }

  ngOnInit() {
  }

}
